import { RankingConstants } from "../constants/RankingConstants";
import { utilEnvironment } from "./utilEnvironment";
var UtilRanking = /** @class */ (function () {
    function UtilRanking() {
        var _this = this;
        this.playerNameParam = "{playerName}";
        this.languageParam = "{language}";
        this.languageFullParam = "&language={language}";
        this.pageSizeParam = "{pageSize}";
        this.positionParam = "{position}";
        this.coopNameParam = "{coopName}";
        this.getHighScoreServerUrl = function () {
            if (utilEnvironment.isProduction()) {
                return process.env.REACT_APP_HIGHSCORE_URL_PRODUCTION;
            }
            else if (utilEnvironment.isIntegration() || utilEnvironment.isDevelopment()) {
                return process.env.REACT_APP_HIGHSCORE_URL_INTEGRATION;
            }
            else {
                return process.env.REACT_APP_HIGHSCORE_URL_STAGING;
            }
        };
        this.getRankingPlayerXpUrlByName = function (name, language) {
            var url = _this.getHighScoreServerUrl() + RankingConstants.PlayerPositionByNameUrl;
            url = url.replace(_this.playerNameParam, name);
            if (language) {
                url = url.replace(_this.languageParam, language);
            }
            else {
                url = url.replace(_this.languageFullParam, "");
            }
            return url;
        };
        this.getRankingPlayerXpUrlByPosition = function (position, language) {
            var url = _this.getHighScoreServerUrl() + RankingConstants.PlayerPositionUrl;
            return _this.getRankingUrl(url, position, language);
        };
        this.getRankingCoopXpUrlByName = function (name, language) {
            var url = _this.getHighScoreServerUrl() + RankingConstants.CoopPositionByNameUrl;
            url = url.replace(_this.coopNameParam, name);
            if (language) {
                url = url.replace(_this.languageParam, language);
            }
            else {
                url = url.replace(_this.languageFullParam, "");
            }
            return url;
        };
        this.getRankingCoopXpUrlByPosition = function (position, language) {
            var url = _this.getHighScoreServerUrl() + RankingConstants.CoopPositionUrl;
            return _this.getRankingUrl(url, position, language);
        };
        this.ajaxGetRequest = function (url) {
            return fetch(url, { method: "GET", mode: "cors" })
                .then(function (res) { return res.json(); })
                .catch(function (err) { return undefined; });
        };
        this.getRankingUrl = function (baseUrl, position, language) {
            var url = baseUrl
                .replace(_this.positionParam, position.toString())
                .replace(_this.pageSizeParam, RankingConstants.PageSize.toString());
            if (language) {
                url = url.replace(_this.languageParam, language);
            }
            else {
                url = url.replace(_this.languageFullParam, "");
            }
            return url;
        };
    }
    return UtilRanking;
}());
export var utilRanking = new UtilRanking();



//////////////////
// WEBPACK FOOTER
// ./src/utils/utilRanking.ts
// module id = 421
// module chunks = 3